<template>
  <div class="hy-index">
    <userinfo></userinfo>
    <!--列表-->
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title active" style="margin-bottom:10px;">
          我的会议订单
        <!--  <van-dropdown-menu>
            <van-dropdown-item v-model="value1" :options="option1" @change="changeType" />
          </van-dropdown-menu>-->
        </h5>
        <van-list v-model="loading" :finished="finished" :finished-text="moreText" @load="onLoad">
          <van-cell v-for="(item,index) in tuiList" :key="item.id">
            <div class="order_nobox">
              <div class="order_statusbox">
                <span class="o_time">{{item.order_info.order_no}}</span>
                <span class="o_status">{{item.order_info.order_status_str}}</span>
              </div>
            </div>

            <div class="imgbox">
              <router-link class="nav-link" :to="'/orderDetails/'+item.order_info.order_no">
              <img :src="item.conference.conference.cover_url" alt />
              <span class="text_icon" v-if="item.conference.conference.status_str == '待发布'">{{item.conference.conference.status_str }}</span>
              <span class="text_icon icon_yellow" v-else-if="item.conference.conference.status_str == '已发布' || item.conference.conference.status_str == '报名中'">{{item.conference.conference.status_str }}</span>
              <span class="text_icon icon_black" v-else-if="item.conference.conference.status_str == '会议中'">{{item.conference.conference.status_str }}</span>
              <span class="text_icon icon_blue" v-else-if="item.conference.conference.status_str == '已结束'">{{item.conference.conference.status_str }}</span>
              <span class="text_icon icon_yellow" v-else-if="item.conference.conference.status_str == '未到报名时间'">{{item.conference.conference.status_str }}</span>
              <span class="text_icon icon_black" v-else-if="item.conference.conference.status_str == '报名截止'">{{item.conference.conference.status_str }}</span>
              <span class="text_icon icon_black" v-else>{{item.conference.conference.status_str }}</span>
              <!-- <span class="text_icon icon_black">已结束</span> -->
                        <!-- <span class="text_icon icon_blue">活动中</span> -->
            </router-link>
            </div>
            <div class="textbox">
              <div class="title">
                <router-link class="nav-link" :to="'/orderDetails/'+item.order_info.order_no">
                <h5>{{item.conference.conference.name}}</h5>
                <span class="type" v-if="item.conference.conference.type == 1">会议</span>
                <span class="type" v-else-if="item.conference.conference.type == 2">沙龙</span>
                <span class="type" v-else-if="item.conference.conference.type == 3">活动</span>
                <!-- <span class="type">活动</span> -->
                </router-link>
              </div>
              <div class="textinfo">
                <span class="iconfont">&#xe67f;</span>
                {{item.conference.conference.start_time,'Y-M-D'|formatDates}}~{{item.conference.conference.end_time,'Y-M-D'|formatDates}}
              </div>
              <div class="textinfo">
                <span class="iconfont">&#xe64d;</span>
                {{item.conference.conference.region}}&nbsp;{{item.conference.conference.specific_address}}
              </div>
              <div class="order_nobox">
                <div class="order_statusbox border">
                  <span class="o_time">{{item.order_info.start_time,'Y-M-D h:m:s'|formatDates}}</span>
                  <span class="o_status">合计：￥{{item.order_info.amount}}</span>
                 </div>
                 <div class="btnBox">
                   <a class="nav-link blue" v-if="item.conference.conference.jump_page == 1" :href="'/index/Conference/template?id='+item.conference.conference.id"><span class="text">会议首页</span></a>
                   <router-link class="nav-link blue" v-else-if="item.conference.conference.jump_page == 2" :to="'/info/'+item.conference.conference.id"><span class="text">会议首页</span></router-link>
                   <router-link class="nav-link blue" v-else-if="item.conference.conference.jump_page == 3" :to="'/shares/1?id='+item.conference.conference.id"><span class="text">会议首页</span></router-link>
                   <router-link class="nav-link blue" :to="'/orderDetails/'+item.order_info.order_no"><span class="text">查看订单</span></router-link>
                   <router-link class="nav-link yellow" :to="'/Meetpeoples/'+item.order_info.order_no" v-if="item.order_info.order_status == 'waitting' || item.order_info.order_status == 'offline'"><span class="text">立即付款</span></router-link>
                   <a class="nav-link hui" href="javascript:;"  v-if="item.order_info.order_status == 'waitting'  || item.order_info.order_status == 'offline'" @click.stop="closeOrder(index)"><span class="text">取消订单</span></a>
                    <a class="nav-link blue" v-if="item.order_info.order_status == 'finished'"  @click.stop="backMoney(item)" >申请退款</a>
                 </div>
              </div>
            </div>

          </van-cell>
        </van-list>
      </div>
    </div>
      <van-dialog v-model="tuikuan" title="温馨提示" show-cancel-button :before-close="CloseKa">
      <div class="tuikuan_tips" v-if="tuiData?.conference.conference.refund_reminder != ''">
        {{tuiData?.conference.conference.refund_reminder}}
      </div>
      <van-field v-model="tuiText" label="" placeholder="请输入退款原因" class="kaInput" v-else/>
    </van-dialog>
    <!--底部按钮-->
   <!-- <div class="hy-fixed-userBtn">
      <router-link class="iconfont fixed-link" to="/">&#xe60e;</router-link>
    </div>-->
  </div>
</template>
<script>
  import {
    formatDates
  } from "../../assets/js/date"
  import userinfo from '@/components/common/userinfo'
  export default {
    components: {
      userinfo
    },
    data() {
      return {
        option1: [{
            text: '全部订单',
            value: 0
          },
          {
            text: '待付款',
            value: 1
          },
          {
            text: '已完成',
            value: 2
          }
        ],
        value1: 0,
        moreText: '没有更多了',
        searchValue: "",
        tuiList: [],
        loading: false,
        finished: false,
        page: 0,
        pagesize: 10,

        tuikuan:false,
        tuiText:'',
        tuiData:null,
      };
    },
    created() {
      var _this = this;
      _this.$WXConfig.wxShowMenu({
        ifshare: true,
        that: _this,
        data: ''
      });

    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
         //退款
    backMoney(data){
      var _this =this;
      _this.tuiText = '';
      _this.tuiData = data;
      _this.tuikuan = true;
    },
    async  CloseKa(action, done){
        var _this =this;
        if(action == 'confirm'){
          if(_this.tuiText == '' && _this.tuiData?.conference?.conference.refund_reminder == ''){
            _this.$toast('退款原因不能为空！')
            done(false); 
            return false;
          } 
          let url = "/ac1/conference/refund";//退款原因
            let params = {
              order_on:_this.tuiData.order_info.order_no,
              reason:_this.tuiText
            };
          _this.$post(url, params).then(res => {
              _this.tuikuan = false;
              if (res.code == "1") {
                _this.$toast('您的退款信息已提交，您的退款申请小编已经进入审核！'); 
              }else{
                _this.$toast(res.msg);
               done();
              }
            },function(res){
              console.log(res.msg);
            });
        } 
        if(action == 'cancel'){
          done();
        }
      },
      //banner跳转方法
      goPath(path) {
        if (path == "") {
          return false;
        }
        // this.$router.push(path);
        window.location.href = path;
      },
      /* 初始化数据列表 */
      onLoad(page, pagesize) {
        var _this = this;
        let url = "/ac1/conference/myOrderList";
        let params = {
          page: _this.page,
          pagesize: _this.pagesize
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            // 加载状态结束
            _this.loading = false;
            if (res.posts.length < _this.pagesize) {
              _this.finished = true;
              if (_this.page == 1 && res.posts.length == 0) {
                _this.moreText = '暂无内容';
              }
            }
            res.posts.forEach(v => {
              _this.tuiList.push(v);
            });
            _this.page = _this.page + 1;
          }else{
            _this.$toast(res.msg);
          }
        },function(res){
          console.log(res.msg);
        });
      },
      changeType() {
        var _this = this;
        _this.tuiList = [];
        _this.page = 1;
        _this.moreText = '没有更多了';
        _this.finished = false;
      },
      closeOrder(i){
        var _this = this;
        _this.$dialog.confirm({
          message: '是否确定取消订单？',
        })
          .then(() => {
          // on confirm
          var thisbox = _this.tuiList[i];
          let url = "/ac1/conference/closeOrder";
          let params = {
            order_no:thisbox.order_info.order_no
          };
          _this.$post(url, params).then(res => {
            if (res.code ==  1) {
              thisbox.order_info.order_status_str = '已取消';
              thisbox.order_info.order_status = 'cancel';
              _this.$toast('订单取消成功！');
            }else{
              _this.$toast(res.msg);
            }
          },function(res){
            console.log(res.msg);
          });
        })
          .catch(() => {
          // on cancel
        });
      }
    }
  };
</script>
<style lang="less">
  .order_nobox{
    width: 100%;
    padding: 10px 0px;
    .order_statusbox{
      width: 100%;
      overflow: hidden;
      padding: 0 15px;
      span{
        color: #999;
        font-size: 28px;
        &.o_time{
          float: left;
        }
        &.o_status{
          float: right;
          color: #fe6333;
        }
      }
      &.border{
        border-top: 2px solid #ebebeb;
        border-bottom: 2px solid #ebebeb;
        padding: 15px;
      }
    }
    .btnBox{
      width: 100%;
      display: flex;
      padding-top: 20px;
      a{
        display: block;
        flex: 1;
        overflow: hidden;
        text-align: center;
        &.blue{
          color: #1994fb;
        }
        &.yellow{
          color: #fe6333;
        }
        &.hui{
          color: #999;
        }
      }
    }
  }
</style>
